import dayjs from 'dayjs';

import { useTranslation } from 'react-i18next';

import Typography from 'components/global/Typography';

import useLocale from 'hooks/useLocale';

import * as S from './ExpiryDateViewer.styled';

const ExpiryDateViewer = ({ value }) => {
	const { getLocaleDate } = useLocale();
	const { t } = useTranslation();

	if (!value) return <Typography>-</Typography>;

	const today = dayjs().startOf('day');
	const expiryDate = dayjs(value).startOf('day');
	const isExpired = today.isAfter(expiryDate);
	const remainingDays = expiryDate.diff(today, 'day');

	return (
		<S.Container style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
			<Typography color={isExpired ? 'var(--red)' : 'var(--green)'}>{getLocaleDate(value)}</Typography>
			{!isExpired && remainingDays >= 0 && (
				<Typography variant="caption" color="var(--green)">
					({remainingDays === 0 ? t('today') : `${remainingDays} ${t('days')}`})
				</Typography>
			)}
		</S.Container>
	);
};

export default ExpiryDateViewer;
